<template>
    <iframe frameborder="0" style="height: 100%; width: 100%" :src="$data.vpn" marginheight="1" marginwidth="1" seamless="seamless" scrolling="yes" allowtransparency="true"></iframe>
</template>
<script>
  export default {
    name:'Live',
    data () {
      return {
        vpn: this.$store.state.url_api_live + this.gsm_ip
      }
    },
    props: {
        gsm_ip: String,
    }
  }
</script>
<style>
#t {
    text-align: center;
}
</style>/html/body
